import { render, staticRenderFns } from "./GroupDialogStep2.vue?vue&type=template&id=0d23e7a6&"
import script from "./GroupDialogStep2.vue?vue&type=script&lang=ts&"
export * from "./GroupDialogStep2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports